import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Modal } from 'flowbite';
import { InputType } from 'src/app/models/enums';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { images } from 'src/images';

@Component({
  selector: 'app-modal-change-driver',
  templateUrl: './modal-change-driver.component.html',
  styleUrl: './modal-change-driver.component.scss',
  standalone: false,
})
export class ModalChangeDriverComponent {
  @Input() id: string;
  @Input() modal: Modal;
  @Input() clientId?: number;
  @Input() assignedDriver: { value: any; label: string }[] = [];
  @Input() valueSelected?: any;
  @Output() action = new EventEmitter<any>();

  public InputType = InputType;
  public images = images;

  public buttonDisabled = false;

  public changeDriverFormControl: FormGroup;
  public hasErrors: boolean = false;
  public error: string = '';

  constructor(public literalService: LiteralService) {}

  change = (driverId: any) => {
    this.valueSelected = driverId;
  };
}
